import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

interface OpenBankingContextProps {
  isOpenBanking: boolean;
  toggleOpen: () => void;
}

const OpenBankingContext = createContext<OpenBankingContextProps | undefined>(
  undefined
);

export const OpenBankingProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpenBanking, setIsOpen] = useState<boolean>(() => {
    const storedIsOpen = localStorage.getItem("openBanking");
    return storedIsOpen ? JSON.parse(storedIsOpen) : false;
  });

  const toggleOpen = () => {
    setIsOpen((prevIsOpen) => {
      const newIsOpen = !prevIsOpen;
      localStorage.setItem("openBanking", JSON.stringify(newIsOpen));
      return newIsOpen;
    });
  };

  useEffect(() => {
    localStorage.setItem("openBanking", JSON.stringify(isOpenBanking));
  }, [isOpenBanking]);

  return (
    <OpenBankingContext.Provider value={{ isOpenBanking, toggleOpen }}>
      {children}
    </OpenBankingContext.Provider>
  );
};

export const useOpenBanking = (): OpenBankingContextProps => {
  const context = useContext(OpenBankingContext);
  if (!context) {
    throw new Error(
      "useOpenBanking must be used within an OpenBankingProvider"
    );
  }
  return context;
};
